import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn, initials, tintFor } from '@/lib/utils';

export function UserAvatar({
  name,
  id,
  src,
  size = 22,
  className,
}: {
  name: string;
  id: string;
  src?: string;
  size?: number;
  className?: string;
}) {
  return (
    <AvatarPrimitive.Root
      className={cn('inline-flex shrink-0 overflow-hidden rounded-full align-middle', className)}
      style={{ width: size, height: size }}
      title={name}
    >
      {src ? <AvatarPrimitive.Image src={src} alt={name} className="h-full w-full object-cover" /> : null}
      <AvatarPrimitive.Fallback
        className="flex h-full w-full items-center justify-center font-medium text-white"
        style={{ background: tintFor(id), fontSize: Math.max(9, size * 0.42) }}
        delayMs={0}
      >
        {initials(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
